import { render, staticRenderFns } from "./ScannerInput.vue?vue&type=template&id=18c21a44&scoped=true&"
import script from "./ScannerInput.vue?vue&type=script&lang=js&"
export * from "./ScannerInput.vue?vue&type=script&lang=js&"
import style0 from "./ScannerInput.vue?vue&type=style&index=0&id=18c21a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c21a44",
  null
  
)

export default component.exports